import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { i18nReady } from './lib/i18n'
import { initializeSentry } from './lib/sentry'
import { captureReferralFromUrl } from './lib/referral'

initializeSentry()
/* F-159: keep `?ref=` before anything rewrites the address. */
captureReferralFromUrl()

/* Mount after the active locale is in. Only one locale is bundled now, fetched
   on demand, so rendering first would paint raw keys for a frame. A failed load
   still mounts — English fallbacks beat a blank page. */
i18nReady.catch(() => {}).then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
})